<template>
<div id="siteframe">
	<!-- content -->
	<div id="content">
		<div id="_page_content"><div class="column_100">
	<div id="main" min_height="400" style="; width: 100%"><div>
	<div class="heroband" style="background: #1e2338 url(/static/images/hero-radiology.png) center center no-repeat; background-size: cover;">
<h1>Powerful Insights</h1>
<p>Your business is our business.</p>
</div></div>


<div>
	<div class="band bg-gray" style="background: #f2f2f2;">
<div class="container center padded">
<div class="row">
<div class="col-md-4 col-xs-12"><img class="floater" src="/static/images/icon-efficiency.png">
<h3>Rad Staffing Efficiency</h3>
<p>Your radiologists are your most valuable resources. Our productivity tools and workload heat maps maps allow you to function with optimal efficiency.</p>
</div>
<div class="col-md-4 col-xs-12"><img class="floater" src="/static/images/icon-service.png">
<h3>Service Excellence</h3>
<p>We help you provide excellent service by measuring and reporting your turnaround times.</p>
</div>
<div class="col-md-4 col-xs-12"><img class="floater" src="/static/images/icon-dailyupdates.png">
<h3>Daily Updates</h3>
<p>Dashboards are updated daily allowing you to micromanage your business.</p>
</div>
</div>
<div class="row">
<div class="col-md-4 col-xs-12"><img class="floater" src="/static/images/icon-eliminate.png">
<h3>Eliminate Concerns</h3>
<p>Isolate, address, and resolve potential issues before they become problems.</p>
</div>
<div class="col-md-4 col-xs-12"><img class="floater" src="/static/images/icon-fast.png">
<h3>Fast and Flexible</h3>
<p>We enable you to monitor and manage the exact information you want allowing you to quickly create incredibly specific, detailed reports.</p>
</div>
<div class="col-md-4 col-xs-12">
<div class="ctabox">
<h3>Get a Free Demo</h3>
<p>See how you can stay on top of any internal or external influences that are affecting your business.</p>
<p><a href="/free-demo/"><button class="button">Free Demo</button></a></p>
</div>
</div>
</div>
</div>
</div></div>


</div></div>
<div style="clear: both;"></div>
</div>		<div style="clear: both;"></div>
	</div>
	<!-- end content -->	
</div>
</template>

<script>
    import {EventBus} from '../event-bus.js'

    export default {
        name: 'benefits',
        data () {
            return {
               
            }
        },
        mounted(){

            
        },
        methods:{
            showNoty: function(){
                EventBus.$emit('noty', {type:'success',msg:'hurray!'});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/js/components/Benefits.vue